module.exports = __webpack_public_path__ + "static/media/btn.267470af.png";


//////////////////
// WEBPACK FOOTER
// ./src/staticPage/bindCehicleActivity/image/btn.png
// module id = 419
// module chunks = 0